import { render, staticRenderFns } from "./TheOrder.vue?vue&type=template&id=025b01b4&"
import script from "./TheOrder.vue?vue&type=script&lang=js&"
export * from "./TheOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports